<template>
  <div id="app">
    <div v-if="isBlockedBrowser" class="browser-mask">
      <div class="browser-tip">
        <i class="el-icon-warning-outline"></i>
        <h3>请使用普通浏览器</h3>
      </div>
    </div>
    <router-view v-if="!isBlockedBrowser" />
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      isBlockedBrowser: false
    }
  },
  created() {
    this.checkBlockedBrowser()
  },
  methods: {
    checkBlockedBrowser() {
      const ua = navigator.userAgent.toLowerCase()
      const isWechat = ua.indexOf('micromessenger') !== -1
      const isQQBrowser = ua.indexOf('mqqbrowser') !== -1 || ua.indexOf('qqbrowser') !== -1
      this.isBlockedBrowser = isWechat || isQQBrowser
    }
  }
}
</script>

<style>
#app {
  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB',
    'Microsoft YaHei', '微软雅黑', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100vh;
}

.browser-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.browser-tip {
  text-align: center;
  padding: 40px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.browser-tip i {
  font-size: 60px;
  color: #f56c6c;
  margin-bottom: 20px;
}

.browser-tip h3 {
  font-size: 24px;
  color: #303133;
  margin: 0 0 10px 0;
}

.wechat-tip p {
  font-size: 16px;
  color: #606266;
  margin: 0;
}
</style>
